// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.animated-button {
    min-width: 10rem;
    display: flex;
    align-items: center;
    color: white;
    text-decoration: none;
    cursor: pointer;
    overflow: hidden;
    padding: 0;
    border-radius: 0;
    background: transparent;
    border: none;
    font-family: inherit;
    font-size: inherit;
    border-top: 1px solid white;
    border-bottom: 1px solid white;
    background-image: linear-gradient(to bottom, white 0, white 100%), linear-gradient(to bottom, white 0, white 100%), linear-gradient(to bottom, white 0, white 100%), linear-gradient(to bottom, white 0, white 100%);
    background-position: 100% 100%, 0 100%, 100% 0, 0 0;
    background-repeat: no-repeat;
    background-size: 1px 8px;
}

.button-wrapper {
    display: flex;
    align-items: center;
    width: 100%;
    height: 3.5rem;
}

.button-text-holder {
    width: 100%;
    text-align: center;
    padding: 1.12rem 1.5rem;
}

.button-text-wrap {
    position: relative;
    overflow: hidden;
    width: 100%;
    margin: 0 auto;
}

.button-text {
    display: inline-block;
    position: relative;
    white-space: nowrap;
    font-size: 0.9rem;
    font-family: "Noto Sans", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
    font-weight: 600;
    transition: transform 0.6s cubic-bezier(0.77, 0, 0.175, 1);
}

.button-text::after {
    content: attr(data-text);
    position: absolute;
    top: 100%;
    left: 50%;
    transform: translateX(-50%);
    white-space: nowrap;
}

.animated-button:hover .button-text {
    transform: translateY(-100%);
}

.button-icon-holder {
    padding: 1.25rem 1.37rem;
    display: flex;
    align-items: center;
    background-image: linear-gradient(to bottom, white 0, white 100%), linear-gradient(to bottom, white 0, white 100%);
    background-repeat: no-repeat;
    background-position: 0 100%, 0 0;
    background-size: 1px 24px;
    position: relative;
}

.button-icon-text {
    position: relative;
    width: 20px;
    height: 20px;
    overflow: hidden;
}

.button-icon,
.button-icon.hover {
    position: absolute;
    top: 0;
    left: 0;
    width: 24px;
    height: 24px;
    transition: transform 0.6s ease;
    transform-style: preserve-3d;
    stroke: white;
}

.button-icon {
    transform: translate3d(0%, 0, 0);
}

.button-icon.hover {
    transform: translate3d(-120%, 0, 0);
}

.animated-button:hover .button-icon {
    transform: translate3d(120%, 0, 0);
}

.animated-button:hover .button-icon.hover {
    transform: translate3d(0%, 0, 0);
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/AnimatedButton.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,qBAAqB;IACrB,eAAe;IACf,gBAAgB;IAChB,UAAU;IACV,gBAAgB;IAChB,uBAAuB;IACvB,YAAY;IACZ,oBAAoB;IACpB,kBAAkB;IAClB,2BAA2B;IAC3B,8BAA8B;IAC9B,oNAAoN;IACpN,mDAAmD;IACnD,4BAA4B;IAC5B,wBAAwB;AAC5B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;IACX,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;IACjB,2FAA2F;IAC3F,gBAAgB;IAChB,0DAA0D;AAC9D;;AAEA;IACI,wBAAwB;IACxB,kBAAkB;IAClB,SAAS;IACT,SAAS;IACT,2BAA2B;IAC3B,mBAAmB;AACvB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,wBAAwB;IACxB,aAAa;IACb,mBAAmB;IACnB,kHAAkH;IAClH,4BAA4B;IAC5B,gCAAgC;IAChC,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,gBAAgB;AACpB;;AAEA;;IAEI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,+BAA+B;IAC/B,4BAA4B;IAC5B,aAAa;AACjB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,gCAAgC;AACpC","sourcesContent":[".animated-button {\n    min-width: 10rem;\n    display: flex;\n    align-items: center;\n    color: white;\n    text-decoration: none;\n    cursor: pointer;\n    overflow: hidden;\n    padding: 0;\n    border-radius: 0;\n    background: transparent;\n    border: none;\n    font-family: inherit;\n    font-size: inherit;\n    border-top: 1px solid white;\n    border-bottom: 1px solid white;\n    background-image: linear-gradient(to bottom, white 0, white 100%), linear-gradient(to bottom, white 0, white 100%), linear-gradient(to bottom, white 0, white 100%), linear-gradient(to bottom, white 0, white 100%);\n    background-position: 100% 100%, 0 100%, 100% 0, 0 0;\n    background-repeat: no-repeat;\n    background-size: 1px 8px;\n}\n\n.button-wrapper {\n    display: flex;\n    align-items: center;\n    width: 100%;\n    height: 3.5rem;\n}\n\n.button-text-holder {\n    width: 100%;\n    text-align: center;\n    padding: 1.12rem 1.5rem;\n}\n\n.button-text-wrap {\n    position: relative;\n    overflow: hidden;\n    width: 100%;\n    margin: 0 auto;\n}\n\n.button-text {\n    display: inline-block;\n    position: relative;\n    white-space: nowrap;\n    font-size: 0.9rem;\n    font-family: \"Noto Sans\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, sans-serif;\n    font-weight: 600;\n    transition: transform 0.6s cubic-bezier(0.77, 0, 0.175, 1);\n}\n\n.button-text::after {\n    content: attr(data-text);\n    position: absolute;\n    top: 100%;\n    left: 50%;\n    transform: translateX(-50%);\n    white-space: nowrap;\n}\n\n.animated-button:hover .button-text {\n    transform: translateY(-100%);\n}\n\n.button-icon-holder {\n    padding: 1.25rem 1.37rem;\n    display: flex;\n    align-items: center;\n    background-image: linear-gradient(to bottom, white 0, white 100%), linear-gradient(to bottom, white 0, white 100%);\n    background-repeat: no-repeat;\n    background-position: 0 100%, 0 0;\n    background-size: 1px 24px;\n    position: relative;\n}\n\n.button-icon-text {\n    position: relative;\n    width: 20px;\n    height: 20px;\n    overflow: hidden;\n}\n\n.button-icon,\n.button-icon.hover {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 24px;\n    height: 24px;\n    transition: transform 0.6s ease;\n    transform-style: preserve-3d;\n    stroke: white;\n}\n\n.button-icon {\n    transform: translate3d(0%, 0, 0);\n}\n\n.button-icon.hover {\n    transform: translate3d(-120%, 0, 0);\n}\n\n.animated-button:hover .button-icon {\n    transform: translate3d(120%, 0, 0);\n}\n\n.animated-button:hover .button-icon.hover {\n    transform: translate3d(0%, 0, 0);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
